import { utc } from '@date-fns/utc'
import { Card, CardContent, Skeleton, Box, Tab, Tabs } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useSearch } from '@tanstack/react-router'
import { addMonths, startOfMonth } from 'date-fns'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { StatisticsTabSchema } from '../schema/statisticsTabSchema'
import { I18NAwareLocalizationProvider } from '@/components/I18NAwareLocalizationProvider'
import { SingleLineTextInputSkeleton } from '@/components/SingleLineTextInputSkeleton'

const today = new Date()
export const StatisticsPendingComponent: React.FC = () => {
    const { t } = useTranslation()

    const { from, to, tab } = useSearch({
        from: '/__base-layout/admin/statistics',
    })

    const parsedDateFrom = React.useMemo(
        () =>
            from === undefined ? startOfMonth(today, { in: utc })
            : typeof from === 'string' ? new Date(from)
            : from,
        [from]
    )
    const parsedDateTo = React.useMemo(
        () =>
            to === undefined ? startOfMonth(addMonths(today, 1))
            : typeof to === 'string' ? new Date(to)
            : to,
        [to]
    )

    return (
        <Card>
            <title>{t('common.statistics')}</title>

            <CardContent>
                <Box
                    sx={{
                        my: 2,
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <I18NAwareLocalizationProvider>
                        <DatePicker
                            label={t('common.from')}
                            value={parsedDateFrom}
                            disabled={true}
                            sx={{ flex: 1, minWidth: 200 }}
                        />

                        <DatePicker
                            label={t('common.to')}
                            value={parsedDateTo}
                            disabled={true}
                            sx={{ flex: 1, minWidth: 200 }}
                        />
                    </I18NAwareLocalizationProvider>
                </Box>

                <Box
                    sx={{
                        my: 2,
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <SingleLineTextInputSkeleton
                        style={{ flex: 1, minWidth: 200 }}
                        margin={false}
                    />
                    <SingleLineTextInputSkeleton
                        style={{ flex: 1, minWidth: 200 }}
                        margin={false}
                    />
                </Box>

                <Tabs value={tab}>
                    <Tab
                        value={'project_hours' as StatisticsTabSchema}
                        label={t('statistics.hoursPerProject')}
                        disabled={true}
                    />
                    <Tab
                        value={'hours_in_selection' as StatisticsTabSchema}
                        label={t('statistics.hoursInTimespan')}
                        disabled={true}
                    />
                    <Tab
                        value={
                            'compare_worked_hours_to_wtm' as StatisticsTabSchema
                        }
                        label={t('statistics.compareHoursToWorkingTimeModel')}
                        disabled={true}
                    />
                </Tabs>

                <Skeleton width={200} height={64} />
                <Box sx={{ height: 300, mt: 1 }}>
                    <Skeleton
                        width={'100%'}
                        height={300}
                        style={{ transform: 'unset' }}
                    />
                </Box>

                <Skeleton width={200} height={64} />
                <Box sx={{ height: 300, mt: 1 }}>
                    <Skeleton
                        width={'100%'}
                        height={300}
                        style={{ transform: 'unset' }}
                    />
                </Box>
            </CardContent>
        </Card>
    )
}
